import { format } from 'date-fns';

export default (input, pattern = 'MMMM dd, yyyy') => {
  if (!input) return '-';

  let date = input;

  if (typeof date === 'object' && typeof date.toDate === 'function') {
    date = date.toDate();
  }

  return format(new Date(date), pattern);
};
